import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { api } from '../lib/api';

export default function PublicFooter() {
  const { t } = useTranslation();
  const [about, setAbout] = useState(null);
  useEffect(() => {
    api.get('/about').then(r => setAbout(r.data)).catch(() => {});
  }, []);
  return (
    <footer className="bg-[#3D2817] text-[#FBF8F3] mt-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="font-serif text-3xl leading-none tracking-[0.15em] uppercase mb-4">
            COSMETISSAGE<sup className="text-[0.45em] ml-1 text-[#C5A059] font-sans">®</sup>
          </div>
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#C5A059] mb-4" data-testid="footer-brand-mark">
            A registered brand
          </div>
          <p className="font-serif italic text-lg text-white/70 max-w-md mb-6">
            {t('footer.tagline')}
          </p>
          <div className="text-xs text-white/50 italic max-w-md">
            {t('footer_contact.brand_distributed')} <span className="text-white/80 font-semibold not-italic">GLOBAL HAIR &amp; BEAUTY SRL</span>{about?.company_vat ? <> · <span className="font-mono not-italic text-white/60">VAT {about.company_vat}</span></> : null}.
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-[#C5A059] mb-4">{t('footer_contact.navigation')}</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/catalog" className="hover:text-[#C5A059] transition-colors">{t('nav.catalog')}</Link></li>
            <li><Link to="/about" className="hover:text-[#C5A059] transition-colors">{t('nav.about')}</Link></li>
            <li><Link to="/private-label" className="hover:text-[#C5A059] transition-colors">Private Label / OEM</Link></li>
            <li><Link to="/admin" className="hover:text-[#C5A059] transition-colors">{t('nav.admin')}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-xs uppercase tracking-widest text-[#C5A059] mb-4" data-testid="footer-contact-heading">{t('about.contact')}</div>
          <div className="space-y-4 text-sm text-white/75 font-sans">
            <div data-testid="footer-hq">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]/70 mb-1">— {t('footer_contact.registered_hq')}</div>
              <address className="not-italic leading-snug">
                Via Duchessa Jolanda 17<br />Turin · Italy
              </address>
            </div>
            <div data-testid="footer-showroom">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]/70 mb-1">— {t('footer_contact.showroom')}</div>
              <address className="not-italic leading-snug">
                Viale Abruzzi 14/7<br />
                20131 Milano · Italy
              </address>
            </div>
            <div data-testid="footer-email">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]/70 mb-1">— {t('footer_contact.sales')}</div>
              <a href="mailto:sales@cosmetissagekeratin.com" className="hover:text-[#C5A059] transition-colors break-all">sales@cosmetissagekeratin.com</a>
            </div>
            {about?.contact_whatsapp && (
              <div data-testid="footer-whatsapp">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#C5A059]/70 mb-1">— {t('footer_contact.whatsapp')}</div>
                <a href={`https://wa.me/${about.contact_whatsapp.replace(/[^0-9]/g, '')}`} target="_blank" rel="noreferrer" className="hover:text-[#C5A059] transition-colors">
                  {about.contact_whatsapp}
                </a>
              </div>
            )}
          </div>
        </div>

        {/* QR — Google Maps direction */}
        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-[#C5A059] mb-4">{t('footer_contact.locate_us')}</div>
          {about?.google_maps_qr ? (
            <a
              href="https://www.google.com/maps/search/?api=1&query=Viale+Abruzzi+14/7,+20131+Milano"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-map-qr"
              className="group block"
            >
              <div className="bg-white p-2 w-32 md:w-full max-w-[160px] aspect-square">
                <img src={about.google_maps_qr} alt="Google Maps QR — COSMETISSAGE Milan showroom" className="w-full h-full object-contain" />
              </div>
              <div className="mt-2 text-[9px] uppercase tracking-[0.3em] text-[#C5A059]/80 group-hover:text-[#C5A059] transition-colors">
                {t('footer_contact.scan_maps')}
              </div>
            </a>
          ) : (
            <div className="text-xs text-white/40 italic">Milan showroom map</div>
          )}
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-2 text-xs uppercase tracking-widest text-white/50">
          <div>© {new Date().getFullYear()} COSMETISSAGE<sup className="text-[0.6em]">®</sup> · {t('footer.rights')}</div>
          <div className="normal-case tracking-normal text-white/40">{t('footer_contact.distributed_by')} GLOBAL HAIR &amp; BEAUTY SRL</div>
        </div>
      </div>
    </footer>
  );
}
